<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<h1>Colors</h1>
<div *ngIf="colors && (colors.list$ | async) as colorsSync">
	<span
		class="color-cell"
		*ngFor="let color of colorsSync | keyvalue"
		[style.background-color]="color.value.color"
	></span>
</div>

<h1>Roles</h1>
<div *ngIf="roles && (roles.list$ | async) as rolesSync">
	<span class="role-chunk" *ngFor="let role of rolesSync | keyvalue">
		<span class="role-name">{{ role.value.view.roleName }}</span>
		<span class="color-cell" [style.background-color]="role.value.view.color"></span>
	</span>
</div>

<button (click)="changeColor1()">Change color 1</button>
<button (click)="deleteColor2()">Delete color 2</button>
<button (click)="changeRole1()">Change color of Role 1</button>
<button (click)="addRole()">Add Role</button>
